export const GET_REPORT = 'GET_REPORT';
export const GET_FILTERS = 'GET_FILTERS';
export const EXCEL = 'EXCEL';
export const PDF = 'PDF';
